/**
 * Screen Flow section wrapper.
 *
 * Routing:
 *   /screen-flow                         → Reports listing
 *   /screen-flow?preset=...              → Standalone builder (deep link)
 *   /screen-flow/new                     → New screen flow report builder
 *   /screen-flow/reports/:id             → Saved report builder
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { ScreenFlowBuilder } from './ScreenFlowBuilder';

export function ScreenFlowPage() {
  return (
    <SectionPage
      basePath="/screen-flow"
      BuilderComponent={ScreenFlowBuilder}
      queryParamKeys={['preset', 'start']}
    />
  );
}
